import { defineElement, FC, onDidLoad, useBindMethod, useElement, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { useStore } from '@atomify/kit';
import { VirtualTourState, virtualTourStore } from '@features/virtual-tour/store';
import { VRTourKRPanoInterface } from '@features/virtual-tour/types/view';
import { KrpanoElement } from '@molecules/krpano';
import { updateSelectedPano } from '@store/krpano';
import { useStylesheet } from '@utilities/hooks';

import style from './vr-tour-krpano-view.scss';

const SCENE_PREFIX = 'scene_';

const VRTourKRPanoView: FC<VRTourKRPanoInterface> = () => {
    const [krpanoId] = useProp<string>('krpanoId');
    const [vrTourId] = useProp<string>('vrTourId');
    const krpano = useElement<KrpanoElement>('bpd-krpano');
    const [vrStore, subscribe] = useStore<VirtualTourState>(virtualTourStore);

    useStylesheet(style);

    onDidLoad(() => {
        handleView(vrStore);
    });

    subscribe(handleView, [vrTourId]);

    function handleView(state: VirtualTourState) {
        const currentView = state[vrTourId]?.currentView;

        if (currentView?.type === '3d') {
            const sceneId = !currentView.apartmentBuildingId
                ? SCENE_PREFIX + currentView.id
                : undefined;
            updateSelectedPano(vrTourId, currentView.source, sceneId);
        }
    }

    const goBack = () => krpano.current?.goBack();
    const zoomIn = () => krpano.current?.zoomIn();
    const zoomOut = () => krpano.current?.zoomOut();

    useBindMethod('zoomIn', zoomIn);
    useBindMethod('zoomOut', zoomOut);
    useBindMethod('goBack', goBack);

    return (
        <div class="vr-tour-krpano-view__wrapper">
            <bpd-krpano
                class="vr-tour-krpano-view__krpano"
                krpano-id={krpanoId}
                store-id={vrTourId}
            />
        </div>
    );
};

VRTourKRPanoView.props = {
    krpanoId: {
        type: String,
        required: true,
        reflectToAttr: true,
    },
    vrTourId: {
        type: String,
        required: true,
    },
};

defineElement('vr-tour-krpano-view', VRTourKRPanoView);
